import ToastEventBus from '@/util/toastEventBus'

// eslint-disable-next-line symbol-description
const AppNotifySymbol = Symbol('AppNotifySymbol')

const NotifyService = {
    add: (message) => {
        ToastEventBus.emit('add', message)
    },
    removeGroup: (group) => {
        ToastEventBus.emit('remove-group', group)
    },
    removeAllGroups: () => {
        ToastEventBus.emit('remove-all-groups')
    }
}

// export declare const notify: {
//   add(message: unknown): void;
//   removeGroup(group: string): void;
//   removeAllGroups(): void;
// }

export {
    AppNotifySymbol,
    NotifyService
}
// declare module '@vue/runtime-core' {
//   export interface ComponentCustomProperties {
//     $notify: typeof notify;
//   }
// }

export default {
    install: (app) => {
        app.config.globalProperties.$notify = { ...NotifyService }
    }
}
